import React from 'react'
import type { SVGProps } from 'react'

export default function ZhFlag(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24px'
      height='24px'
      viewBox='0 0 512 512'
      {...props}
    >
      <mask id='circleFlagsCn'>
        <circle cx={256} cy={256} r={256} fill='#fff' />
      </mask>
      <g mask='url(#circleFlagsCn)'>
        <path fill='#d80027' d='M0 0h512v512H0z' />
        <path
          fill='#ffda44'
          d='m140 180 16 49h52l-42 31 16 49-42-31-42 31 16-49-42-31h52zm194 14-12 36h-36l29 21-11 36 29-21 29 21-11-36 29-21h-36zm64 86-12 36h-36l29 21-11 36 29-21 29 21-11-36 29-21h-36zm-128 56-12 36h-36l29 21-11 36 29-21 29 21-11-36 29-21h-36z'
        />
      </g>
    </svg>
  )
}
